// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"verify-email-m__wrapper__1vlb6","label":"verify-email-m__label__3iSp7"};